import { apiGet } from 'shared/services/api/resource';
import { COURTS, DATE_OPTIONS } from 'modules/jogador/booking/content';
import { Court, DateOption } from 'modules/jogador/booking/types';

export function fetchDateOptions(): Promise<DateOption[]> {
  return apiGet(DATE_OPTIONS, '/arenas/current/available-dates');
}

// Em produção a disponibilidade das quadras depende da data escolhida (seção 5:
// horários ocupados/fixos mudam por dia) — por isso já recebe dateId, mesmo que o
// mock ainda devolva os mesmos slots para qualquer data.
export function fetchCourtAvailability(dateId: string): Promise<Court[]> {
  return apiGet(COURTS, `/arenas/current/courts?date=${dateId}`);
}
